/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AziendaFromJSON, AziendaToJSON, } from './Azienda';
import { BusinessManagerDtoFromJSON, BusinessManagerDtoToJSON, } from './BusinessManagerDto';
import { ClienteDtoFromJSON, ClienteDtoToJSON, } from './ClienteDto';
/**
 * Check if a given object implements the OrderSFSearchFilterDto interface.
 */
export function instanceOfOrderSFSearchFilterDto(value) {
    return true;
}
export function OrderSFSearchFilterDtoFromJSON(json) {
    return OrderSFSearchFilterDtoFromJSONTyped(json, false);
}
export function OrderSFSearchFilterDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'businessManager': json['businessManager'] == null ? undefined : (json['businessManager'].map(BusinessManagerDtoFromJSON)),
        'aziendaList': json['aziendaList'] == null ? undefined : (json['aziendaList'].map(AziendaFromJSON)),
        'clienteDtoList': json['clienteDtoList'] == null ? undefined : (json['clienteDtoList'].map(ClienteDtoFromJSON)),
    };
}
export function OrderSFSearchFilterDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'businessManager': value['businessManager'] == null ? undefined : (value['businessManager'].map(BusinessManagerDtoToJSON)),
        'aziendaList': value['aziendaList'] == null ? undefined : (value['aziendaList'].map(AziendaToJSON)),
        'clienteDtoList': value['clienteDtoList'] == null ? undefined : (value['clienteDtoList'].map(ClienteDtoToJSON)),
    };
}
